// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page transition: the pink/blue diagonal split closes over one screen and
   opens on the next. Same seam as the body background (30% top, 18% bottom). */
.splitWipe {
  position: absolute;
  inset: 0;
  /* Above the room's loading spinner (20) and marquees (10). */
  z-index: 30;
  pointer-events: none;
  overflow: hidden;
}

/* Bright "crack" that shows through the gap between the two halves. */
.splitWipe .wipeGlow {
  position: absolute;
  inset: 0;
  background: var(--white);
  opacity: 0;
}

.splitWipe .wipePink,
.splitWipe .wipeBlue {
  position: absolute;
  inset: -2px;
}

.splitWipe .wipePink {
  background: linear-gradient(160deg, #f57fb6, #ec5f97);
  clip-path: polygon(0 0, calc(30% - 3px) 0, calc(18% - 3px) 100%, 0 100%);
}

.splitWipe .wipeBlue {
  background: linear-gradient(200deg, #5cc8f8, #27a8ef);
  clip-path: polygon(calc(30% + 3px) 0, 100% 0, 100% 100%, calc(18% + 3px) 100%);
}

/* Closing: halves slide in from their own edge and meet on the diagonal,
   then the seam flashes. Total ~0.8s (SPLIT_WIPE_MS). */
.splitWipe.closing .wipeGlow {
  animation: wipeGlowIn 0.3s ease-out 0.45s both;
}

.splitWipe.closing .wipePink {
  animation: wipeInPink 0.55s cubic-bezier(0.7, 0, 0.2, 1) 0.12s both;
}

.splitWipe.closing .wipeBlue {
  animation: wipeInBlue 0.55s cubic-bezier(0.7, 0, 0.2, 1) 0.12s both;
}

/* Opening: start closed with the seam lit, hold a beat, then break apart. */
.splitWipe.opening .wipeGlow {
  opacity: 1;
  animation: wipeGlowOut 0.35s ease-in 0.4s both;
}

.splitWipe.opening .wipePink {
  animation: wipeOutPink 0.6s cubic-bezier(0.6, 0, 0.3, 1) 0.2s both;
}

.splitWipe.opening .wipeBlue {
  animation: wipeOutBlue 0.6s cubic-bezier(0.6, 0, 0.3, 1) 0.2s both;
}

@keyframes wipeInPink {
  from { transform: translateX(-32%); }
  to { transform: translateX(0); }
}

@keyframes wipeInBlue {
  from { transform: translateX(84%); }
  to { transform: translateX(0); }
}

@keyframes wipeOutPink {
  from { transform: translateX(0); }
  to { transform: translateX(-32%); }
}

@keyframes wipeOutBlue {
  from { transform: translateX(0); }
  to { transform: translateX(84%); }
}

@keyframes wipeGlowIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes wipeGlowOut {
  from { opacity: 1; }
  to { opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .splitWipe .wipePink,
  .splitWipe .wipeBlue,
  .splitWipe .wipeGlow {
    animation-duration: 0.01s;
    animation-delay: 0s;
  }
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/split-wipe.css"],"names":[],"mappings":"AAAA;+EAC+E;AAC/E;EACE,kBAAkB;EAClB,QAAQ;EACR,6DAA6D;EAC7D,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,wEAAwE;AAC1E;;AAEA;EACE,qDAAqD;EACrD,8EAA8E;AAChF;;AAEA;wDACwD;AACxD;EACE,8CAA8C;AAChD;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,mEAAmE;AACrE;;AAEA,4EAA4E;AAC5E;EACE,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,wBAAwB,EAAE;AACjC;;AAEA;EACE,OAAO,0BAA0B,EAAE;EACnC,KAAK,wBAAwB,EAAE;AACjC;;AAEA;EACE,OAAO,wBAAwB,EAAE;EACjC,KAAK,2BAA2B,EAAE;AACpC;;AAEA;EACE,OAAO,wBAAwB,EAAE;EACjC,KAAK,0BAA0B,EAAE;AACnC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;;;IAGE,yBAAyB;IACzB,mBAAmB;EACrB;AACF","sourcesContent":["/* Page transition: the pink/blue diagonal split closes over one screen and\n   opens on the next. Same seam as the body background (30% top, 18% bottom). */\n.splitWipe {\n  position: absolute;\n  inset: 0;\n  /* Above the room's loading spinner (20) and marquees (10). */\n  z-index: 30;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n/* Bright \"crack\" that shows through the gap between the two halves. */\n.splitWipe .wipeGlow {\n  position: absolute;\n  inset: 0;\n  background: var(--white);\n  opacity: 0;\n}\n\n.splitWipe .wipePink,\n.splitWipe .wipeBlue {\n  position: absolute;\n  inset: -2px;\n}\n\n.splitWipe .wipePink {\n  background: linear-gradient(160deg, #f57fb6, #ec5f97);\n  clip-path: polygon(0 0, calc(30% - 3px) 0, calc(18% - 3px) 100%, 0 100%);\n}\n\n.splitWipe .wipeBlue {\n  background: linear-gradient(200deg, #5cc8f8, #27a8ef);\n  clip-path: polygon(calc(30% + 3px) 0, 100% 0, 100% 100%, calc(18% + 3px) 100%);\n}\n\n/* Closing: halves slide in from their own edge and meet on the diagonal,\n   then the seam flashes. Total ~0.8s (SPLIT_WIPE_MS). */\n.splitWipe.closing .wipeGlow {\n  animation: wipeGlowIn 0.3s ease-out 0.45s both;\n}\n\n.splitWipe.closing .wipePink {\n  animation: wipeInPink 0.55s cubic-bezier(0.7, 0, 0.2, 1) 0.12s both;\n}\n\n.splitWipe.closing .wipeBlue {\n  animation: wipeInBlue 0.55s cubic-bezier(0.7, 0, 0.2, 1) 0.12s both;\n}\n\n/* Opening: start closed with the seam lit, hold a beat, then break apart. */\n.splitWipe.opening .wipeGlow {\n  opacity: 1;\n  animation: wipeGlowOut 0.35s ease-in 0.4s both;\n}\n\n.splitWipe.opening .wipePink {\n  animation: wipeOutPink 0.6s cubic-bezier(0.6, 0, 0.3, 1) 0.2s both;\n}\n\n.splitWipe.opening .wipeBlue {\n  animation: wipeOutBlue 0.6s cubic-bezier(0.6, 0, 0.3, 1) 0.2s both;\n}\n\n@keyframes wipeInPink {\n  from { transform: translateX(-32%); }\n  to { transform: translateX(0); }\n}\n\n@keyframes wipeInBlue {\n  from { transform: translateX(84%); }\n  to { transform: translateX(0); }\n}\n\n@keyframes wipeOutPink {\n  from { transform: translateX(0); }\n  to { transform: translateX(-32%); }\n}\n\n@keyframes wipeOutBlue {\n  from { transform: translateX(0); }\n  to { transform: translateX(84%); }\n}\n\n@keyframes wipeGlowIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes wipeGlowOut {\n  from { opacity: 1; }\n  to { opacity: 0; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .splitWipe .wipePink,\n  .splitWipe .wipeBlue,\n  .splitWipe .wipeGlow {\n    animation-duration: 0.01s;\n    animation-delay: 0s;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
